import { Team__Adrianes } from "../teams/Adrianes";
import { Team__Cerveceros } from "../teams/Cerveceros";
import { Team__Joeles } from "../teams/Joeles";
import { Team__JohnsonBranders } from "../teams/JohnsonBranders";
import { Team__Llamas } from "../teams/Llamas";
import { Team__Natalias } from "../teams/Natalias";
import { Team__PecanBros } from "../teams/PecanBros";
import { Team__Potros } from "../teams/Potros";
import { Team__TheTakeOvers } from "../teams/TheTakeOvers";
import { Team__Thunder } from "../teams/Thunder";

const Adrianes = {
  team: Team__Adrianes,
  playingPlayers: [],

  goals: 29,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros,
  playingPlayers: [],

  goals: 18,
  penaltyGoals: 0,
  isWinner: false,
};

const Joeles = {
  team: Team__Joeles,
  playingPlayers: [],

  goals: 30,
  penaltyGoals: 0,
  isWinner: false,
};

const JohnsonBranders = {
  team: Team__JohnsonBranders,
  playingPlayers: [],

  goals: 23,
  penaltyGoals: 0,
  isWinner: false,
};

const Natalias = {
  team: Team__Natalias,
  playingPlayers: [],

  goals: 47,
  penaltyGoals: 0,
  isWinner: false,
};

const Thunder = {
  team: Team__Thunder,
  playingPlayers: [],

  goals: 40,
  penaltyGoals: 0,
  isWinner: false,
};

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 42,
  penaltyGoals: 0,
  isWinner: false,
};

const PecanBros = {
  team: Team__PecanBros,
  playingPlayers: [],

  goals: 42,
  penaltyGoals: 0,
  isWinner: false,
};

const TheTakeOvers = {
  team: Team__TheTakeOvers,
  playingPlayers: [],

  goals: 38,
  penaltyGoals: 0,
  isWinner: false,
};

const Potros = {
  team: Team__Potros,
  playingPlayers: [],

  goals: 34,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada4 = {
  jornadaPosition: 4,
  matches: [
    {
      team1: Thunder,
      team2: Adrianes,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2024-08-01",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: JohnsonBranders,
      team2: PecanBros,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2024-08-01",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Natalias,
      team2: Potros,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2024-08-01",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Cerveceros,
      team2: Llamas,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2024-08-01",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Joeles,
      team2: Adrianes,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2024-08-01",
      time: "15:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: TheTakeOvers,
      team2: PecanBros,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2024-08-01",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
